import { createContext } from "react";
import jwt_decode from "jwt-decode";
// import { NotificationManager } from "react-notifications";
import axios from "axios";
import axiosAuth from "../Axios/Interceptors";
import * as Utility from "../Shared/Utility";
const AppContext = createContext(null) as any;

AppContext.LogInUserName = "";
AppContext.LogInUserImage = "";
AppContext.LogInUserRole = "";
AppContext.UserGeneralData = [];

AppContext.Token = "atk";
AppContext.RefreshToken = "atkr";
AppContext.ReturnURL = "ru";
AppContext.SNTKN = "sntkn";
AppContext.App = 3;
AppContext.PermittedApps = "";
AppContext.PermittedAppList = [];

AppContext.LocalToken = ""; //"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiNnpESHFvYUc4STJxaWp2M3NoN3lSZz09IiwidXNlcm5hbWUiOiJQRkkgU3VwcG9ydCIsInVzZXJpbWFnZSI6Imh0dHBzOi8vZmlsZXMuamxybWVuYWJ1c2luZXNzdG9vbHMuY29tL2pscmZpbGVzZHBhdXRoL0p1T3d3cW4vb3JpZ2luYWwtMDcwODIwMjMxNDA0NTYtOTk0MTdlOTYtYWIzMi00YzUwLTg4ZmEtNGJjY2JhM2YwOThjL0p1T3d3cW4ucG5nIiwicm9sZSI6IkFkbWluIiwic3VicyI6InB0ZGxycmVmQVArbzBPZkhNRTdlMVN0MFVGakc1dz09IiwiZXhwIjoxNjk1NDA2NTY1fQ.e2ifsWPiPgUU9-a5FYeAFfbqIc9FtMBmiN3xFGytszE";

//AppContext.Domain = "domain=localhost";
AppContext.Domain = "domain=.jlrmenabusinesstools.com";

AppContext.OldAppLink = "https://rep.jlrmenabusinesstools.com";
AppContext.AppBaseURL = "https://apirepdata.jlrmenabusinesstools.com/";
AppContext.AppAuthBaseURL = "https://apiauthdata.jlrmenabusinesstools.com/";
AppContext.FilesAPI = "https://bp.jlrmenabusinesstools.com/";
AppContext.CommAPI = "https://apicommdata.jlrmenabusinesstools.com/";
AppContext.FileManegmentAPI =
  "https://apimanagefilesdata.jlrmenabusinesstools.com/";
AppContext.RefreshInProgressMessage =
  "Refresh data is in progress. screen will be updated with the latest data shortly.";
AppContext.RefreshDoneMessage = "Data has been refreshed.";

AppContext.selectedCurrencyType = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
AppContext.selectedTabBrand = [0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3];
AppContext.NumberOfYears = 3;
AppContext.NumberOfYearsArray = [0, 1, 2, 3, 4];
AppContext.NumberOfMonthsArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
AppContext.BusinessPlanGeneralData = {};
AppContext.BPID = 0;
AppContext.SectionID = 0;
AppContext.MasterBPID = 0;
AppContext.BreadCrumbArray = [];

AppContext.IsProduction = false;
AppContext.ScoreCardFiltersIDs = {
  ScreenID: 0,
  Dealers: 15,
  Facilities: 9,
  Years: 0,
  Months: 0,
  Brand: 0,
};

AppContext.NetworkTotalScore = 0;
AppContext.SalesTotalScore = 0;
AppContext.AftersalesTotalScore = 0;

AppContext.SetCookie = (cname: any, cvalue: any, exmins: any) => {
  const d = new Date();
  if (exmins == 0) {
    d.setTime(0);
  } else {
    d.setTime(d.getTime() + exmins * 60 * 1000);
  }
  let expires = "expires=" + d;
  document.cookie =
    cname + "=" + cvalue + ";" + expires + ";" + AppContext.Domain + ";path=/";
};

AppContext.GetCookie = (cname: any) => {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

AppContext.ConvertDateTimeToLocal = (date: any) => {
  date = new Date(date);
  var localOffset = date.getTimezoneOffset() * 60000;
  var localTime = date.getTime();
  date = localTime - localOffset;
  date = new Date(date);

  // let text = date.toLocaleString();
  // date = new Date(text);

  return date;
};

AppContext.ShowNotification = (Type: any, Message: any) => {
  alert(Message);
  // switch (Type) {
  //   case "info":
  //     NotificationManager.info(Message);
  //     break;
  //   case "success":
  //     NotificationManager.success(Message, "Success");
  //     break;
  //   case "warning":
  //     NotificationManager.warning(Message, "Close after 3000ms", 3000);
  //     break;
  //   case "error":
  //     NotificationManager.error(Message, "Error!", 5000, () => {
  //       //alert('callback');
  //     });
  //     break;
  // }
};

AppContext.GetJWTAndDecode = () => {
  var token = AppContext.GetCookie(AppContext.Token);
  if (token && token !== "") var UserInfo: any = jwt_decode(token);
  if (UserInfo && UserInfo !== "") {
    AppContext.LogInUserName = UserInfo.username;
    //Router.push("welcome");
  } else {
    //Router.push("login");
  }
};

AppContext.IsUserLoggedIn = async () => {
  if (AppContext.LocalToken && AppContext.LocalToken !== "" && !AppContext.IsJwtExpired(AppContext.LocalToken)) {
    AppContext.SetUserInfo(1, AppContext.LocalToken);
    return true;
  } else {
    let ReturnData = await AppContext.CheckLoginValidity();
    if (ReturnData.role === "") {
      console.log("ReturnData false: ");
      console.log(ReturnData);
      return false;
    } else {
      console.log("ReturnData true: ");
      console.log(ReturnData);
      AppContext.SetUserInfo(2, ReturnData);
      return true;
    }
  }
};

AppContext.IsJwtExpired = (token: any) => {
  if (token && token !== "") {
    var UserInfo: any = jwt_decode(token);
    let currentDate = new Date();
    if (UserInfo.exp * 1000 < currentDate.getTime()) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
};

AppContext.SetUserInfo = (type: number, data: any) => {
  if (type === 1) {
    if (data && data !== "") var UserInfo: any = jwt_decode(data);
    if (UserInfo && UserInfo !== "") {
      AppContext.LogInUserName = UserInfo.username;
      AppContext.LogInUserImage = UserInfo.userimage;
      AppContext.LogInUserRole = UserInfo.role;
    }
  } else {
    AppContext.LogInUserName = data.username;
    AppContext.LogInUserImage = data.userimage;
    AppContext.LogInUserRole = data.role;
  }
};

AppContext.CheckLoginValidity = async () => {
  let object = {} as any;
  let ReturnData = { role: "" };
  await axiosAuth
    .post(AppContext.AppAuthBaseURL + "api/SiteUser/CheckLoginValidity", object)
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data.Data[0][0];
        ReturnData = l_response;
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
      return ReturnData;
    });

  return ReturnData;
};

AppContext.CheckAccessAndSettingsBP = async (completeURL: string) => {
  let object = {} as any;
  object.appid = AppContext.App;
  object.other = completeURL;
  let permissionStatus = false;
  await axiosAuth
    .post(
      AppContext.AppAuthBaseURL + "api/SiteUser/CheckAccessAndSettings",
      object
    )
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data.Data[0][0];
        AppContext.PermittedApps = l_response.AppList;
        AppContext.PermittedAppList = response.data.Data[1];
        let Status = l_response.Status;
        if (Status === 1) {
          permissionStatus = true;
        }
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
      return permissionStatus;
    });

  return permissionStatus;
};

AppContext.CheckAccessAsAdmin = async () => {
  let object = {} as any;
  object.appid = AppContext.App;
  let isAdminLoggedIn = false;
  await axiosAuth
    .post(AppContext.AppAuthBaseURL + "api/SiteUser/CheckAccessAsAdmin", object)
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data;
        let Status = l_response.Status;
        if (Status === 1) {
          isAdminLoggedIn = true;
        }
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
      return isAdminLoggedIn;
    });

  return isAdminLoggedIn;
};

AppContext.GetBusinessPlanGeneralData = () => {
  let object = {} as any;
  object.bpid = AppContext.BPID;
  axiosAuth
    .post(
      AppContext.AppBaseURL + "api/PFIBusinessPlan/GetBusinessPlanGeneralData",
      object
    )
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data.Data[0][0];
        AppContext.BusinessPlanGeneralData = l_response;
        Utility.SetBPGeneralData();
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

AppContext.GetUserGeneralData = () => {
  let object = {} as any;
  axiosAuth
    .post(AppContext.AppBaseURL + "api/SiteUser/GetUserGeneralData", object)
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data.Data;
        AppContext.UserGeneralData = l_response;
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

AppContext.PTCheckPasswordValidation = (FieldValue: any) => {
  //var RegExpresson = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  var RegExpresson = /^(?=.*["}{)(|,'?><_~!@#\$%\^&\*^%:;.`/-])/;
  //var l_boolValid = RegExpresson.test(FieldValue);
  var l_boolValid = true;
  var HasWhiteSpace = false;
  var Message = "";
  if (/\s/.test(FieldValue)) {
    // It has any kind of whitespace
    HasWhiteSpace = true;
  }
  if (HasWhiteSpace) {
    l_boolValid = false;
    IsAnyError = true;

    Message =
      "<br /><span class='p-error'>White spaces are not allowed.</span>";
  }
  var IsAnyError = false;
  if (FieldValue.length < 8) {
    Message +=
      "<br /><span class='p-error'>A minimum of 8 characters required.</span>";
    IsAnyError = true;
    l_boolValid = false;
  } else {
    Message +=
      "<br /><span class='p-ok'>A minimum of 8 characters required.</span>";
  }

  if (!/[a-z]/.test(FieldValue)) {
    Message +=
      "<br /><span class='p-error'>At least one lowercase letter is required.</span>";
    IsAnyError = true;
    l_boolValid = false;
  } else {
    Message +=
      "<br /><span class='p-ok'>At least one lowercase letter is required.</span>";
  }

  if (FieldValue == FieldValue.toLowerCase()) {
    Message +=
      "<br /><span class='p-error'>At least one capital letter is required.</span>";
    IsAnyError = true;
    l_boolValid = false;
  } else {
    Message +=
      "<br /><span class='p-ok'>At least one capital letter is required.</span>";
  }

  if (!/\d/.test(FieldValue)) {
    Message +=
      "<br /><span class='p-error'>At least one number is required.</span>";
    IsAnyError = true;
    l_boolValid = false;
  } else {
    Message +=
      "<br /><span class='p-ok'>At least one number is required.</span>";
  }
  // if (/^[a-zA-Z0-9- ]*$/.test(FieldValue) == true) {
  if (!RegExpresson.test(FieldValue)) {
    Message +=
      "<br /><span class='p-error'>At least one special character (e.g. @) is required.</span>";
    IsAnyError = true;
    l_boolValid = false;
  } else {
    Message +=
      "<span class='p-ok'>At least one special character (e.g. @) is required.</span>";
  }
  // }

  return { Valid: l_boolValid, Message: Message };
};

AppContext.GenerateUniqueGUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

AppContext.GetFileIconToDisplay = (FilePath: any) => {
  var IconURL = FilePath;
  var parts = FilePath.split(".");
  var ext = parts[parts.length - 1];
  switch (ext.toLowerCase()) {
    case "pdf":
      IconURL = "/DragDropIcons/pdficon.jpg";
      break;
    case "docx":
      IconURL = "/DragDropIcons/Word.jpg";
      break;
    case "doc":
      IconURL = "/DragDropIcons/Word.jpg";
      break;
    case "xlsx":
      IconURL = "/DragDropIcons/xls_icon.png";
      break;
    case "xls":
      IconURL = "/DragDropIcons/xls_icon.png";
      break;
    case "pptx":
      IconURL = "/DragDropIcons/ppt.png";
      break;
    case "ppt":
      IconURL = "/DragDropIcons/ppt.png";
      break;
    case "wav":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "mid":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "midi":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "wma":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "mp3":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "ogg":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "rma":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "au":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "ea":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "avi":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "mp4":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "divx":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "wmv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "mkv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "flv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "avi":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "vob":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "ogv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "wmv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "m4v":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "mov":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "wmv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "zip":
      IconURL = "/DragDropIcons/zip.png";
      break;
    case "rar":
      IconURL = "/DragDropIcons/zip.png";
      break;
    default:
      IconURL = FilePath;
  }
  return IconURL;
};

AppContext.SortJsonData = (JsonData: any, ColumnName: any) => {
  let SortedData = JsonData.sort((a: any, b: any) => {
    if (a[ColumnName] < b[ColumnName]) {
      return -1;
    }
  });

  return SortedData;
};

export default AppContext;
